import { render, staticRenderFns } from "./options.vue?vue&type=template&id=53e1e50e&scoped=true&"
import script from "./options.vue?vue&type=script&lang=js&"
export * from "./options.vue?vue&type=script&lang=js&"
import style0 from "./options.vue?vue&type=style&index=0&id=53e1e50e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e1e50e",
  null
  
)

export default component.exports